import { useCallback, useEffect, useState } from "react";
import {
    hasAthleteCollegeListLoaded,
    loadAthleteCollegeNames,
    peekAthleteCollegeNames,
    rememberAthleteCollegeName,
    subscribeAthleteCollegeNames,
} from "./athleteCollegeListCache";

export function useAthleteCollegeList(username: string, enabled: boolean) {
    const [names, setNames] = useState<string[]>(() => peekAthleteCollegeNames(username));
    const [ready, setReady] = useState(() => hasAthleteCollegeListLoaded(username));

    useEffect(() => {
        if (!enabled || !username) {
            return;
        }
        return subscribeAthleteCollegeNames((next) => {
            setNames(next);
            if (hasAthleteCollegeListLoaded(username)) {
                setReady(true);
            }
        });
    }, [enabled, username]);

    useEffect(() => {
        if (!enabled || !username) {
            return;
        }
        void loadAthleteCollegeNames(username).then(() => {
            setReady(hasAthleteCollegeListLoaded(username));
        });
    }, [enabled, username]);

    const remember = useCallback((name: string) => {
        rememberAthleteCollegeName(name);
    }, []);

    return { names, remember, ready: !enabled || ready };
}
